import React, { useState } from 'react';
import './GuestVerification.css';
import { apiRequest, parseResponse } from './utils/api';
import { useLanguage } from './i18n/LanguageContext';

const GuestVerification = ({ onSendOTP, onBack }) => {
  const { t } = useLanguage();
  const [mobileNumber, setMobileNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSendOTP = async () => {
    if (mobileNumber.length !== 10) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await apiRequest('/register_or_fetch', {
        method: 'POST',
        skipAuth: true,
        body: JSON.stringify({ mobileNumber })
      });

      const data = await parseResponse(response);
      if (!response.ok || data?.status === false) {
        throw new Error(data?.message || 'Unable to send OTP. Please try again.');
      }

      onSendOTP({
        mobileNumber,
        countryCode: 'IN +91',
        existingUser: data?.data?.existingUser,
        otpRequired: data?.data?.otpRequired
      });
    } catch (err) {
      setError(err.message || 'Unable to send OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = mobileNumber.length === 10;

  return (
    <div className="guest-verification-screen">
      <div className="guest-verification-content">
        <button className="back-button" onClick={onBack} aria-label="Go back">
          <img
            src={process.env.PUBLIC_URL + '/images/back_button.svg'}
            alt="Back"
          />
        </button>
        <div className="flex-guest-verf">
          <div className="guest-verf-img">
            <img src={process.env.PUBLIC_URL + '/images/undraw_secure-login_m11a 1.png'} alt="" />
          </div>

          <div className="content-verf-text">
            <div>
              <h1 className="verification-title">{t('Guest verification')}</h1>
              <p className="verification-subtitle">
                Enter your mobile number to continue.
              </p>

              <div className="form-container">
                <div className="form-field">
                  <label className="field-label">{t('Mobile number')}</label>
                  <div className="mobile-input-group">
                    <div className="country-code-selector">
                      <span className="country-code-text">IN +91</span>
                    </div>
                    <input
                      type="tel"
                      className="text-input mobile-input"
                      placeholder="9876543210"
                      value={mobileNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        if (value.length <= 10) {
                          setMobileNumber(value);
                        }
                      }}
                      maxLength="10"
                    />
                  </div>
                </div>
              </div>

              {error && (
                <div className="error-message">{error}</div>
              )}
            </div>

            <button
              className={`send-otp-btn ${isFormValid && !isLoading ? 'active' : ''}`}
              onClick={handleSendOTP}
              disabled={!isFormValid || isLoading}
            >
              {isLoading && <span className="loading-spinner"></span>}
              {isLoading ? 'Sending OTP...' : 'Send OTP'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestVerification;
